module.exports = __webpack_public_path__ + "static/media/background-blend-dark.bfdefa17.jpg";